import p, { Children as R, PureComponent as K } from "react";
import { clsx as N } from "../../../clsx/dist/clsx.js";
import L from "../../../../_virtual/isFunction.js";
import C from "../../../../_virtual/range.js";
import { Layer as D } from "../container/Layer.js";
import { Text as P } from "../component/Text.js";
import { getValueByDataKey as U } from "../util/ChartUtils.js";
import { isNumber as X } from "../util/DataUtils.js";
import { generatePrefixStyle as H } from "../util/CssPrefixUtils.js";
import { filterProps as z } from "../util/ReactUtils.js";
import { point as G } from "../../../d3-scale/src/band.js";
function S(a) {
  "@babel/helpers - typeof";
  return S = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, S(a);
}
function M() {
  return M = Object.assign ? Object.assign.bind() : function(a) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var e in n)
        Object.prototype.hasOwnProperty.call(n, e) && (a[e] = n[e]);
    }
    return a;
  }, M.apply(this, arguments);
}
function j(a, r) {
  var n = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(a);
    r && (e = e.filter(function(t) {
      return Object.getOwnPropertyDescriptor(a, t).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function E(a) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? j(Object(n), !0).forEach(function(e) {
      m(a, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function(e) {
      Object.defineProperty(a, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return a;
}
function Y(a, r) {
  if (!(a instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function W(a, r) {
  for (var n = 0; n < r.length; n++) {
    var e = r[n];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(a, V(e.key), e);
  }
}
function q(a, r, n) {
  return r && W(a.prototype, r), n && W(a, n), Object.defineProperty(a, "prototype", { writable: !1 }), a;
}
function J(a, r, n) {
  return r = O(r), Q(a, F() ? Reflect.construct(r, n || [], O(a).constructor) : r.apply(a, n));
}
function Q(a, r) {
  if (r && (S(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Z(a);
}
function Z(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function F() {
  try {
    var a = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (F = function() {
    return !!a;
  })();
}
function O(a) {
  return O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, O(a);
}
function ee(a, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(r && r.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), r && _(a, r);
}
function _(a, r) {
  return _ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
    return e.__proto__ = t, e;
  }, _(a, r);
}
function m(a, r, n) {
  return r = V(r), r in a ? Object.defineProperty(a, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : a[r] = n, a;
}
function V(a) {
  var r = te(a, "string");
  return S(r) == "symbol" ? r : r + "";
}
function te(a, r) {
  if (S(a) != "object" || !a) return a;
  var n = a[Symbol.toPrimitive];
  if (n !== void 0) {
    var e = n.call(a, r);
    if (S(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(a);
}
var re = function(r) {
  var n = r.data, e = r.startIndex, t = r.endIndex, i = r.x, l = r.width, o = r.travellerWidth;
  if (!n || !n.length)
    return {};
  var s = n.length, d = G().domain(C(0, s)).range([i, i + l - o]), h = d.domain().map(function(u) {
    return d(u);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: d(e),
    endX: d(t),
    scale: d,
    scaleValues: h
  };
}, $ = function(r) {
  return r.changedTouches && !!r.changedTouches.length;
}, A = /* @__PURE__ */ function(a) {
  function r(n) {
    var e;
    return Y(this, r), e = J(this, r, [n]), m(e, "handleDrag", function(t) {
      e.leaveTimer && (clearTimeout(e.leaveTimer), e.leaveTimer = null), e.state.isTravellerMoving ? e.handleTravellerMove(t) : e.state.isSlideMoving && e.handleSlideDrag(t);
    }), m(e, "handleTouchMove", function(t) {
      t.changedTouches != null && t.changedTouches.length > 0 && e.handleDrag(t.changedTouches[0]);
    }), m(e, "handleDragEnd", function() {
      e.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var t = e.props, i = t.endIndex, l = t.onDragEnd, o = t.startIndex;
        l == null || l({
          endIndex: i,
          startIndex: o
        });
      }), e.detachDragEndListener();
    }), m(e, "handleLeaveWrapper", function() {
      (e.state.isTravellerMoving || e.state.isSlideMoving) && (e.leaveTimer = window.setTimeout(e.handleDragEnd, e.props.leaveTimeOut));
    }), m(e, "handleEnterSlideOrTraveller", function() {
      e.setState({
        isTextActive: !0
      });
    }), m(e, "handleLeaveSlideOrTraveller", function() {
      e.setState({
        isTextActive: !1
      });
    }), m(e, "handleSlideDragStart", function(t) {
      var i = $(t) ? t.changedTouches[0] : t;
      e.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), e.attachDragEndListener();
    }), e.travellerDragStartHandlers = {
      startX: e.handleTravellerDragStart.bind(e, "startX"),
      endX: e.handleTravellerDragStart.bind(e, "endX")
    }, e.state = {}, e;
  }
  return ee(r, a), q(r, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(e) {
      var t = e.startX, i = e.endX, l = this.state.scaleValues, o = this.props, s = o.gap, d = o.data, h = d.length - 1, u = Math.min(t, i), v = Math.max(t, i), c = r.getIndexInRange(l, u), g = r.getIndexInRange(l, v);
      return {
        startIndex: c - c % s,
        endIndex: g === h ? h : g - g % s
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(e) {
      var t = this.props, i = t.data, l = t.tickFormatter, o = t.dataKey, s = U(i[e], o, e);
      return L(l) ? l(s, e) : s;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(e) {
      var t = this.state, i = t.slideMoveStartX, l = t.startX, o = t.endX, s = this.props, d = s.x, h = s.width, u = s.travellerWidth, v = s.startIndex, c = s.endIndex, g = s.onChange, f = e.pageX - i;
      f > 0 ? f = Math.min(f, d + h - u - o, d + h - u - l) : f < 0 && (f = Math.max(f, d - l, d - o));
      var T = this.getIndex({
        startX: l + f,
        endX: o + f
      });
      (T.startIndex !== v || T.endIndex !== c) && g && g(T), this.setState({
        startX: l + f,
        endX: o + f,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(e, t) {
      var i = $(t) ? t.changedTouches[0] : t;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: e,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(e) {
      var t = this.state, i = t.brushMoveStartX, l = t.movingTravellerId, o = t.endX, s = t.startX, d = this.state[l], h = this.props, u = h.x, v = h.width, c = h.travellerWidth, g = h.onChange, f = h.gap, T = h.data, I = {
        startX: this.state.startX,
        endX: this.state.endX
      }, y = e.pageX - i;
      y > 0 ? y = Math.min(y, u + v - c - d) : y < 0 && (y = Math.max(y, u - d)), I[l] = d + y;
      var w = this.getIndex(I), b = w.startIndex, x = w.endIndex, B = function() {
        var k = T.length - 1;
        return l === "startX" && (o > s ? b % f === 0 : x % f === 0) || o < s && x === k || l === "endX" && (o > s ? x % f === 0 : b % f === 0) || o > s && x === k;
      };
      this.setState(m(m({}, l, d + y), "brushMoveStartX", e.pageX), function() {
        g && B() && g(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(e, t) {
      var i = this, l = this.state, o = l.scaleValues, s = l.startX, d = l.endX, h = this.state[t], u = o.indexOf(h);
      if (u !== -1) {
        var v = u + e;
        if (!(v === -1 || v >= o.length)) {
          var c = o[v];
          t === "startX" && c >= d || t === "endX" && c <= s || this.setState(m({}, t, c), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var e = this.props, t = e.x, i = e.y, l = e.width, o = e.height, s = e.fill, d = e.stroke;
      return /* @__PURE__ */ p.createElement("rect", {
        stroke: d,
        fill: s,
        x: t,
        y: i,
        width: l,
        height: o
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var e = this.props, t = e.x, i = e.y, l = e.width, o = e.height, s = e.data, d = e.children, h = e.padding, u = R.only(d);
      return u ? /* @__PURE__ */ p.cloneElement(u, {
        x: t,
        y: i,
        width: l,
        height: o,
        margin: h,
        compact: !0,
        data: s
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(e, t) {
      var i, l, o = this, s = this.props, d = s.y, h = s.travellerWidth, u = s.height, v = s.traveller, c = s.ariaLabel, g = s.data, f = s.startIndex, T = s.endIndex, I = Math.max(e, this.props.x), y = E(E({}, z(this.props, !1)), {}, {
        x: I,
        y: d,
        width: h,
        height: u
      }), w = c || "Min value: ".concat((i = g[f]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((l = g[T]) === null || l === void 0 ? void 0 : l.name);
      return /* @__PURE__ */ p.createElement(D, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": e,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[t],
        onTouchStart: this.travellerDragStartHandlers[t],
        onKeyDown: function(x) {
          ["ArrowLeft", "ArrowRight"].includes(x.key) && (x.preventDefault(), x.stopPropagation(), o.handleTravellerMoveKeyboard(x.key === "ArrowRight" ? 1 : -1, t));
        },
        onFocus: function() {
          o.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          o.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, r.renderTraveller(v, y));
    }
  }, {
    key: "renderSlide",
    value: function(e, t) {
      var i = this.props, l = i.y, o = i.height, s = i.stroke, d = i.travellerWidth, h = Math.min(e, t) + d, u = Math.max(Math.abs(t - e) - d, 0);
      return /* @__PURE__ */ p.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: s,
        fillOpacity: 0.2,
        x: h,
        y: l,
        width: u,
        height: o
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var e = this.props, t = e.startIndex, i = e.endIndex, l = e.y, o = e.height, s = e.travellerWidth, d = e.stroke, h = this.state, u = h.startX, v = h.endX, c = 5, g = {
        pointerEvents: "none",
        fill: d
      };
      return /* @__PURE__ */ p.createElement(D, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ p.createElement(P, M({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(u, v) - c,
        y: l + o / 2
      }, g), this.getTextOfTick(t)), /* @__PURE__ */ p.createElement(P, M({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(u, v) + s + c,
        y: l + o / 2
      }, g), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, t = e.data, i = e.className, l = e.children, o = e.x, s = e.y, d = e.width, h = e.height, u = e.alwaysShowText, v = this.state, c = v.startX, g = v.endX, f = v.isTextActive, T = v.isSlideMoving, I = v.isTravellerMoving, y = v.isTravellerFocused;
      if (!t || !t.length || !X(o) || !X(s) || !X(d) || !X(h) || d <= 0 || h <= 0)
        return null;
      var w = N("recharts-brush", i), b = p.Children.count(l) === 1, x = H("userSelect", "none");
      return /* @__PURE__ */ p.createElement(D, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: x
      }, this.renderBackground(), b && this.renderPanorama(), this.renderSlide(c, g), this.renderTravellerLayer(c, "startX"), this.renderTravellerLayer(g, "endX"), (f || T || I || y || u) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(e) {
      var t = e.x, i = e.y, l = e.width, o = e.height, s = e.stroke, d = Math.floor(i + o / 2) - 1;
      return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("rect", {
        x: t,
        y: i,
        width: l,
        height: o,
        fill: s,
        stroke: "none"
      }), /* @__PURE__ */ p.createElement("line", {
        x1: t + 1,
        y1: d,
        x2: t + l - 1,
        y2: d,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ p.createElement("line", {
        x1: t + 1,
        y1: d + 2,
        x2: t + l - 1,
        y2: d + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(e, t) {
      var i;
      return /* @__PURE__ */ p.isValidElement(e) ? i = /* @__PURE__ */ p.cloneElement(e, t) : L(e) ? i = e(t) : i = r.renderDefaultTraveller(t), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(e, t) {
      var i = e.data, l = e.width, o = e.x, s = e.travellerWidth, d = e.updateId, h = e.startIndex, u = e.endIndex;
      if (i !== t.prevData || d !== t.prevUpdateId)
        return E({
          prevData: i,
          prevTravellerWidth: s,
          prevUpdateId: d,
          prevX: o,
          prevWidth: l
        }, i && i.length ? re({
          data: i,
          width: l,
          x: o,
          travellerWidth: s,
          startIndex: h,
          endIndex: u
        }) : {
          scale: null,
          scaleValues: null
        });
      if (t.scale && (l !== t.prevWidth || o !== t.prevX || s !== t.prevTravellerWidth)) {
        t.scale.range([o, o + l - s]);
        var v = t.scale.domain().map(function(c) {
          return t.scale(c);
        });
        return {
          prevData: i,
          prevTravellerWidth: s,
          prevUpdateId: d,
          prevX: o,
          prevWidth: l,
          startX: t.scale(e.startIndex),
          endX: t.scale(e.endIndex),
          scaleValues: v
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(e, t) {
      for (var i = e.length, l = 0, o = i - 1; o - l > 1; ) {
        var s = Math.floor((l + o) / 2);
        e[s] > t ? o = s : l = s;
      }
      return t >= e[o] ? o : l;
    }
  }]);
}(K);
m(A, "displayName", "Brush");
m(A, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
export {
  A as Brush
};
